import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  data: any;
  reason: string;
  status: ReduxStateType;
}

const initialState: InitialState = {
  data: null,
  reason: "",
  status: ReduxStateType.ERROR,
};

const cancelRequestSlice = createSlice({
  name: "cancelRequest",
  initialState,
  reducers: {
    setReasonData: (state, action) => {
      state.reason = action.payload;
    },

    setCancelRequestData: (state, action) => {
      state.data = action.payload;
    },
    cancelRequestStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    cancelRequestSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    cancelRequestFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  setReasonData,
  setCancelRequestData,
  cancelRequestStart,
  cancelRequestSuccess,
  cancelRequestFailed,
} = cancelRequestSlice.actions;

export default cancelRequestSlice.reducer;
